import { render, staticRenderFns } from "./RegistroEntrega.vue?vue&type=template&id=195f695a&scoped=true&"
import script from "./RegistroEntrega.vue?vue&type=script&lang=js&"
export * from "./RegistroEntrega.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195f695a",
  null
  
)

export default component.exports